




















































































































































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import InvoiceHeader from "../components/InvoiceHeader.vue";
import VToolbar from "../../common/components/VToolbar.vue";
import InvoiceItem from "../components/InvoiceItem.vue";
import Invoice from "../../../usecases/orders/invoice";
import InvoiceService from "../../../usecases/orders/invoice-service";
import MoveEvent from "../presenters/move-event";
import InvoiceItemModel from "@/usecases/orders/invoice-item";
import { client } from "@/api/request";
import InvoiceApi from "@/api/orders/invoice-api";
import InvoiceStatus from "@/usecases/orders/invoice-status";
import InvoiceStatusTranslater from "@/usecases/orders/invoice-status-translater";
import BankAccountApi from "@/api/orders/bank-account-api";
import BankAccount from "../../../entities/bank-account";
import BankAccountOption from "../presenters/bank-account-option";
import VInputWithDropdown from "../../../common/ui/components/VInputWithDropdown.vue";
import BillingRuleApi from "../../../orders/api/billing-rule-api";
import UnitApi from "@/orders/api/unit-api";
import UnitOption from "../presenters/unit-option";
import SelectOption from "../../../common/ui/presenters/select-option";
import PrintApi from "../../../api/orders/print-api";
import TextTemplateModal from "@/views/TextTemplateModal.vue";
import { ESTIMATE_ITEM_LEVEL } from "@/preferences";
import {
  ExpenseCategory,
  getExpenseCategories
} from "@/api/cost/expense-categories-api";
import LoadingButton from "@/components/LoadingButton.vue";

const printApi = new PrintApi(client);
const billingRuleApi = new BillingRuleApi(client);
const bankAccountApi = new BankAccountApi(client);
const invoiceApi = new InvoiceApi(client);
const unitApi = new UnitApi(client);
const service = new InvoiceService(invoiceApi, billingRuleApi);

@Component({
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    LoadingButton,
    TextTemplateModal,
    VInputWithDropdown,
    VToolbar,
    InvoiceHeader,
    InvoiceItem
  }
})
export default class EditInvoicePage extends Vue {
  @Prop({ required: true }) id!: string;

  textTemplateModalOpen = false;
  fields: HeaderItem[] = [
    {
      name: "見積項目",
      subs: [
        { name: "大項目", width: "10vw" },
        { name: "中項目", width: "10vw" },
        { name: "小項目", width: "12vw" },
        { name: "経費カテゴリ", width: "9rem" },
        { name: "数量", width: "5rem" },
        { name: "単位", width: "5rem" },
        { name: "単価", width: "6rem" },
        { name: "見積金額", width: "6rem" },
        { name: "備考", width: "1fr" },
        { name: "操作", width: "4rem" }
      ]
    }
  ];
  invoice = new Invoice();
  unitOptions: SelectOption[] = [];
  expenseCategories: ExpenseCategory[] = [];
  styleGridColumn: string = this.getWidthsString(this.fields);
  printing: boolean = false;

  async createPdf(id: number, printsExcludeTax: boolean) {
    if (!this.printing) {
      this.printing = true;
      const url = await printApi.getInvoicePrint(
        id,
        this.$store.state.accessToken,
        printsExcludeTax
      );
      this.printing = false;
      window.open(url, "請求書印刷");
    } else {
      alert("印刷中です");
    }
  }

  get statusOptions() {
    return InvoiceStatus.all().map(value => ({
      value,
      text: InvoiceStatusTranslater.toJp(value)
    }));
  }

  get childListClassName() {
    return {
      expanded: this.editing
    };
  }

  get bankAccountOptions(): string[] {
    return this.accounts.map(a => new BankAccountOption(a).value);
  }

  goListPage() {
    this.$router.push({
      name: "order-invoice"
    });
  }

  status = "";

  async save() {
    this.status = "progressing";
    try {
      await service.save(this.invoice);
      await this.loadInvoice();
      await this.$store.dispatch("getStatusProject");
      await this.$store.dispatch("setProjectEstimateExpenseSummary");
      alert("保存しました。");
    } catch (e) {
      alert("保存に失敗しました。");
    } finally {
      this.status = "";
    }
  }

  async destroy() {
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await service.destroy(Number(this.id));
    this.goListPage();
    await this.$store.dispatch("getStatusProject");
    await this.$store.dispatch("setProjectEstimateExpenseSummary");
  }

  async calculate() {
    this.invoice = await service.calculate(this.invoice);
  }

  addNewItem() {
    this.invoice.items.push(new InvoiceItemModel());
    this.calculate();
  }

  addNewFiveItems() {
    new Array(5).fill(0).forEach(() => {
      this.invoice.items.push(new InvoiceItemModel());
    });
    this.calculate();
  }

  addNewItemTo(index: number, items: InvoiceItemModel[]) {
    items.splice(index, 0, new InvoiceItemModel());
    this.calculate();
  }

  removeItem(item: InvoiceItemModel, items: InvoiceItemModel[]) {
    const i = items.findIndex(it => it.id === item.id);
    if (i < 0) return;
    items.splice(i, 1);
    this.calculate();
  }

  removeAllItems() {
    if (!confirm("全ての項目を削除します。よろしいですか？")) return;
    this.invoice.items = [];
    this.calculate();
  }

  move(e: MoveEvent) {
    // 子がいる親を子にすることはできない
    const from = e.from.dataset.type;
    const to = e.to.dataset.type;
    const children = e.draggedContext.element.items.length;
    const grandchildren = e.draggedContext.element.items.reduce(
      (total, item) => total + item.items.length,
      0
    );
    return !(
      (from === "parents" && to === "grandchildren" && children > 0) ||
      (from === "children" && to === "grandchildren" && children > 0) ||
      (from === "parents" && to === "children" && grandchildren > 0)
    );
  }

  dragstart() {
    this.editing = true;
  }

  dragend() {
    this.editing = false;
    this.calculate();
  }

  protected async created() {
    await this.loadInvoice();
    await this.initExpenseCategories();
    await this.loadBankAccountOptions();
    await this.initUnitList();
  }

  private editing = false;
  private accounts: BankAccount[] = [];

  private async loadInvoice() {
    this.invoice = await service.find(Number(this.id));
  }

  private async loadBankAccountOptions() {
    if (this.invoice.projectId) {
      this.accounts = await bankAccountApi.ourBankAccounts({
        projectId: this.invoice.projectId
      });
    }
  }

  private async initUnitList() {
    this.unitOptions = [
      { text: "", value: "" },
      ...(await unitApi.findAll()).map(UnitOption)
    ];
  }

  addTextToMention(text: string) {
    if (this.invoice.mention) {
      this.invoice.mention += "\n";
    }
    this.invoice.mention += text;
    this.textTemplateModalOpen = false;
  }

  getWidthsString(header: HeaderItem[]): string {
    const widths: string[] = [];

    header.forEach(item => {
      if (item.subs.length === 0 && item.width) {
        widths.push(item.width);
      } else {
        item.subs.forEach(sub => {
          widths.push(sub.width);
        });
      }
    });

    return widths.join(" ");
  }

  async initExpenseCategories() {
    let includeExpenseCategoryInvoice = false;
    let onlyExpenseCategoryInvoice = false;
    if (this.invoice.estimateId == 0) {
      includeExpenseCategoryInvoice = true;
      onlyExpenseCategoryInvoice = true;
    }
    this.expenseCategories = [
      {
        id: "",
        name: "",
        important: false,
        expense_category_invoice_flg: false
      },
      ...(await getExpenseCategories(
        includeExpenseCategoryInvoice,
        onlyExpenseCategoryInvoice
      ))
    ];
  }

  get expenseCategoryOptions() {
    return this.expenseCategories.map(category => ({
      value: category.id,
      text: category.name
    }));
  }

  upLevel(
    oldParent: InvoiceItemModel | null,
    newParent: Invoice | null,
    item: InvoiceItemModel | null
  ) {
    if (newParent === null || oldParent === null || item === null) {
      return;
    }

    oldParent.items.splice(oldParent.items.indexOf(item), 1);
    newParent.items.splice(newParent.items.indexOf(oldParent) + 1, 0, item);
    this.calculate();
  }

  downLevel(
    oldParent: InvoiceItemModel | null,
    newParent: Invoice | null,
    item: InvoiceItemModel | null
  ) {
    if (newParent === null || oldParent === null || item === null) {
      return;
    }

    oldParent.items.splice(oldParent.items.indexOf(item), 1);
    newParent.items.splice(newParent.items.length, 0, item);
    this.calculate();
  }
}
